








import Component from 'vue-class-component';
import { Page } from '@/layout/mixin/Page';
import PageLayout from '@/common/layout/PageLayout.vue';

@Component({
  components: {
    PageLayout
  }
})
export default class ModelPage extends Page {
  title: string = "Modele - Lista modeli";
}
